import React from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input } from "rbx";

import {
  CustomerSelect,
  SystemCodeSelect,
  BooleanInput,
  LocationSelect,
  BookingCodeSelect
} from "../../../../components/inputs";

import HorizontalRule from "../../../../styles/HorizontalRule";

import { RouteProducts } from "../components";
import { useSystemCodes } from "../../../../utils/hooks";

function Details({ route, editing, onChange }) {
  const SystemCodes = useSystemCodes({
    Category: "BookingCodes",
    CodeName: "BookCatg",
    CodeId: "O"
  });
  return (
    <div className="route-tab-container">
      <Column.Group>
        <Column size={4}>
          <Field kind="group">
            <Control expanded>
              <Label>Route Id</Label>
              <Input
                autocomplete="new"
                name="RouteId"
                readOnly={!editing}
                value={route.RouteId}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <CustomerSelect
                icon="globe"
                label="Customer"
                name="CustomerRecIdRef"
                readOnly={!editing}
                value={route.CustomerRecIdRef}
                variables={{
                  where: { Active: true, OrderCust: true },
                  orderByMulti: ["CustomerNo_ASC"]
                }}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field kind="group">
            <Control expanded>
              <CustomerSelect
                icon="money-bill"
                label="Bill To"
                name="BillToRecIdRef"
                readOnly={!editing}
                value={route.BillToRecIdRef}
                variables={{
                  where: { Active: true, BillToCust: true },
                  orderByMulti: ["CustomerNo_ASC"]
                }}
                onChange={onChange}
              />
            </Control>
            {/* 
            <Control expanded>
              <Label>Mileage</Label>
              <Input
                autocomplete="new"
                type="number"
                name="Mileage"
                value={route.Mileage}
                readOnly={!editing}
                onChange={onChange}
              />
            </Control> */}
          </Field>
          <Field kind="group">
            <Control>
              <Label>Industrial</Label>
              <BooleanInput
                name="IndustrialFlag"
                readOnly={!editing}
                value={route.IndustrialFlag}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>Queens</Label>
              <BooleanInput
                name="MotorOilFlag"
                readOnly={!editing}
                value={route.MotorOilFlag}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>No Bill</Label>
              <BooleanInput
                name="NonBill"
                readOnly={!editing}
                value={route.NonBill}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>Tolls</Label>
              <BooleanInput
                name="Tolls"
                readOnly={!editing}
                value={route.Tolls}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Charge For Tolls</Label>
              <Input
                name="ChargeForTolls"
                readOnly={!editing}
                step="0.1"
                type="number"
                value={route.ChargeForTolls}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column size={4}>
          <Field kind="group">
            <Control expanded>
              <Label>Route Description</Label>
              <Input
                disabled={!editing}
                name="RouteDescription"
                readOnly={!editing}
                value={route.RouteDescription}
                onChange={onChange}
              />
            </Control>
          </Field>

          <Field>
            <Control expanded>
              <Label>Contract</Label>
              <Input
                autocomplete="new"
                name="Contract"
                readOnly={!editing}
                type="text"
                value={route.Contract}
                onChange={onChange}
              />
            </Control>
            {/* <Control expanded>
              <Label>Unloaded Miles</Label>
              <Input
                autocomplete="new"
                type="number"
                name="UnloadedMiles"
                value={route.UnloadedMiles}
                readOnly={!editing}
                onChange={onChange}
              />
            </Control> */}
          </Field>
          {SystemCodes?.data?.length > 0 && (
            <Field>
              <Control expanded>
                <Label>Booking Code</Label>
                <BookingCodeSelect
                  defaults={{ value: "", label: "All" }}
                  disableDefaults={false}
                  disabled={!editing}
                  label="Booking Code"
                  name="BookingCodeRecIdRef"
                  value={route.BookingCodeRecIdRef}
                  where={{
                    CodeCatgRecIdRef: SystemCodes?.data[0]?.RecId /* Orders */
                  }}
                  onChange={onChange}
                />
              </Control>
            </Field>
          )}
        </Column>
        <Column size={4}>
          <Field kind="group">
            <Control expanded>
              <SystemCodeSelect
                icon="globe"
                label="Load Type"
                lookup={{ Category: "Route", Code: "LoadType" }}
                name="LoadTypeRecIdRef"
                readOnly={!editing}
                value={route.LoadTypeRecIdRef}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>Status</Label>
              <BooleanInput
                name="Status"
                readOnly={!editing}
                value={route.Status}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field kind="group">
            <Control expanded>
              <Label>Load Time</Label>
              <Input
                autocomplete="new"
                name="LoadTime"
                readOnly={!editing}
                step="0.25"
                type="number"
                value={route.LoadTime}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Travel Time</Label>
              <Input
                autocomplete="new"
                name="TravelTime"
                readOnly={!editing}
                type="number"
                value={route.TravelTime}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Loaded Miles</Label>
              <Input
                autocomplete="new"
                name="LoadedMiles"
                readOnly={!editing}
                type="number"
                value={route.LoadedMiles}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Unload Time</Label>
              <Input
                autocomplete="new"
                name="UnloadTime"
                readOnly={!editing}
                type="number"
                value={route.UnloadTime}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Return Time</Label>
              <Input
                autocomplete="new"
                name="ReturnToTerminalTime"
                readOnly={!editing}
                type="number"
                value={route.ReturnToTerminalTime}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <HorizontalRule />
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <LocationSelect
                icon="globe"
                label="Start Location"
                name="StartLocationRecIdRef"
                readOnly={!editing}
                value={route?.StartLocationRecIdRef}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <LocationSelect
                icon="globe"
                label="Pickup Location"
                name="PickupLocationRecIdRef"
                readOnly={!editing}
                value={route?.PickupLocationRecIdRef}
                where={{ PickupLocation: true }}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <LocationSelect
                icon="globe"
                label="Delivery Location"
                name="DeliveryLocationRecIdRef"
                readOnly={!editing}
                value={route?.DeliveryLocationRecIdRef}
                where={{ DeliveryLocation: true }}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <LocationSelect
                icon="globe"
                label="Ending Location"
                name="EndingLocationRecIdRef"
                readOnly={!editing}
                value={route?.EndingLocationRecIdRef}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <HorizontalRule />
      <RouteProducts isDispatching route={route} />
    </div>
  );
}
Details.propTypes = {
  route: PropTypes.object,
  editing: PropTypes.bool,
  onChange: PropTypes.func
};

Details.defaultProps = {
  route: {}
};
export default Details;
